var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgConnectionIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_3049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8688 25.5674L18.5391 32.8972L21.7691 36.1272L29.0988 28.7974C29.9908 27.9054 29.9908 26.4594 29.0988 25.5674C28.2069 24.6754 26.7608 24.6754 25.8688 25.5674Z",
    fill: "#B4BBCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4269 38.1295L31.0972 45.4592L27.8672 42.2292L35.1969 34.8995C36.0889 34.0075 37.5349 34.0075 38.4269 34.8995C39.3189 35.7913 39.3189 37.2375 38.4269 38.1295Z",
    fill: "#B4BBCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4625 40.0719C6.8665 40.6679 6.54413 41.4844 6.57212 42.3267L6.79775 49.1091C6.82575 49.9516 6.5035 50.7678 5.90737 51.3638L0 57.2713L6.7265 63.9978L12.634 58.0903C13.23 57.4943 14.0465 57.1719 14.8888 57.1999L21.6711 57.4256C22.5136 57.4536 23.3299 57.1313 23.9259 56.5352L33.0525 47.4086L16.5893 30.9453L7.4625 40.0719Z",
    fill: "#515262"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.80775 52.1191L9.58212 45.3367C9.55412 44.4942 9.87638 43.6779 10.4725 43.0819L19.5991 33.9553L16.589 30.9453L7.4625 40.0718C6.8665 40.6678 6.54413 41.4843 6.57212 42.3266L6.79775 49.1089C6.82575 49.9514 6.5035 50.7677 5.90737 51.3637L0 57.2712L3.01012 60.2813L8.91763 54.3738C9.5135 53.7778 9.83587 52.9614 9.80775 52.1191Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0719 7.4625C40.6679 6.8665 41.4844 6.54413 42.3267 6.57212L49.1091 6.79775C49.9516 6.82575 50.7678 6.5035 51.3638 5.90737L57.2713 0L63.9978 6.7265L58.0903 12.634C57.4943 13.23 57.1719 14.0465 57.1999 14.8888L57.4256 21.6711C57.4536 22.5136 57.1313 23.3299 56.5352 23.9259L47.4086 33.0525L30.9453 16.5893L40.0719 7.4625Z",
    fill: "#515262"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.3368 9.58212L52.1192 9.80775C52.9617 9.83575 53.7779 9.5135 54.3739 8.91737L60.2814 3.00987L57.2713 0L51.3638 5.9075C50.7678 6.5035 49.9513 6.82587 49.1091 6.79787L42.3267 6.57225C41.4842 6.54425 40.6679 6.8665 40.0719 7.46262L30.9453 16.5892L33.9554 19.5994L43.0821 10.4727C43.6779 9.87662 44.4944 9.55425 45.3368 9.58212Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.1015 45.461L36.4453 40.1172L33.2155 36.8874L27.8717 42.2312L31.1015 45.461Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.7734 36.129L27.1172 30.7852L23.8874 27.5554L18.5436 32.8992L21.7734 36.129Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0367 51.0609L36.7031 46.3945L17.6085 27.2999L12.9421 31.9663L32.0367 51.0609Z",
    fill: "#C7CFE2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.9508 34.9711L20.6172 30.3047L17.6072 27.2947L12.9407 31.9611L15.9508 34.9711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9633 12.9391L27.2969 17.6055L46.3915 36.7001L51.0579 32.0337L31.9633 12.9391Z",
    fill: "#C7CFE2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.3101 20.6195L34.9766 15.9531L31.9665 12.9431L27.3001 17.6095L30.3101 20.6195Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_3049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgConnectionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/connection-icon.2780528a.svg";
export { ForwardRef as ReactComponent };